<div class="container-fluid">
  <app-page-header
    icon="fe-settings"
    pretitle="Sistema"
    title="Configurações"
    description="Quem tem acesso à empresa e por onde entram as participações."
  />
</div>

<div class="container-fluid">
  <div class="row">
    @for (c of visibleCards(); track c.title) {
      <div class="col-12 col-md-6 col-xl-4">
        <a class="card settings-card" [routerLink]="[c.link]">
          <div class="card-body d-flex align-items-center">
            <span class="settings-card-icon"><i class="fe {{ c.icon }}"></i></span>
            <div class="ms-3">
              <h4 class="mb-1">{{ c.title }}</h4>
              <p class="small text-muted mb-0">{{ c.description }}</p>
            </div>
            <i class="fe fe-chevron-right ms-auto text-muted"></i>
          </div>
        </a>
      </div>
    } @empty {
      <div class="col-12">
        <div class="card"><div class="card-body text-center text-muted py-5">
          Não tem acesso a configurações. Fale com um administrador.
        </div></div>
      </div>
    }
  </div>
</div>
